/* INVICTUS · BLACK 戲劇效果 + 權益表滑動提示
   純增強層：額外元素全由 JS 注入，不動任何 Liquid 區段的 markup。 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. 會員頁 BLACK 階：進場擕裂 + 滑鼠傾斜 ---- */
  var step = document.querySelector('.iv-mb__step--4');
  if (step) {
    var card = step.querySelector('.iv-mb__step-card');
    if (card) {
      var slash = document.createElement('div');
      slash.className = 'iv-fx-slash';
      slash.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 3; i++) slash.appendChild(document.createElement('i'));
      card.appendChild(slash);

      step.setAttribute('data-fx', reduce ? 'in' : 'pending');
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { step.setAttribute('data-fx', 'in'); io.disconnect(); }
          });
        }, { threshold: 0.35 });
        io.observe(step);
      } else {
        step.setAttribute('data-fx', 'in');
      }

      var art = card.querySelector('img') || card.querySelector('.iv-mb__card-ph');
      var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
      if (art && !reduce && canHover) {
        card.addEventListener('pointermove', function (ev) {
          var r = card.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width - 0.5;
          var py = (ev.clientY - r.top) / r.height - 0.5;
          art.style.transform =
            'perspective(1100px) rotateY(' + (px * 7).toFixed(2) + 'deg) rotateX(' +
            (-py * 7).toFixed(2) + 'deg) translateZ(14px)';
        });
        card.addEventListener('pointerleave', function () { art.style.transform = ''; });
      }
    }
  }

  /* ---- 2. 權益表：讓人看得出來可以左右滑 ---- */
  var wrap = document.querySelector('.iv-mb__table-wrap');
  if (wrap && wrap.parentNode) {
    var sc = document.createElement('div');
    sc.className = 'iv-fx-scroller';
    wrap.parentNode.insertBefore(sc, wrap);
    sc.appendChild(wrap);

    var fade = document.createElement('span');
    fade.className = 'iv-fx-fade';
    fade.setAttribute('aria-hidden', 'true');
    sc.appendChild(fade);

    var hint = document.createElement('p');
    hint.className = 'iv-fx-hint';
    hint.innerHTML = '左右滑動看完整對照 <i>→</i>';
    sc.parentNode.insertBefore(hint, sc.nextSibling);

    var update = function () {
      var max = wrap.scrollWidth - wrap.clientWidth;
      var scrollable = max > 8;
      sc.classList.toggle('is-scrollable', scrollable);
      hint.classList.toggle('is-on', scrollable);
      if (!scrollable) return;
      var atEnd = wrap.scrollLeft >= max - 8;
      sc.classList.toggle('is-end', atEnd);
      hint.classList.toggle('is-done', atEnd);
    };
    wrap.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* 進場時自動輕推一下再彈回——這是最直接的「我可以滑」提示 */
    if (!reduce && 'IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          io2.disconnect();
          var max = wrap.scrollWidth - wrap.clientWidth;
          if (max < 40) return;
          var peak = Math.min(84, max), start = null, dur = 1150;
          var tick = function (ts) {
            if (start === null) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var q = p < 0.5 ? p / 0.5 : 1 - (p - 0.5) / 0.5;
            wrap.scrollLeft = peak * (q * q * (3 - 2 * q));
            if (p < 1) requestAnimationFrame(tick); else { wrap.scrollLeft = 0; update(); }
          };
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.4 });
      io2.observe(wrap);
    }
  }

  /* ---- 3. 升等特效：進 BLACK 時換成金色擕裂版 ---- */
  var ms = document.querySelector('.iv-ms');
  if (!ms || ms.getAttribute('data-tier') !== 'BLACK') return;
  var fx = ms.querySelector('.iv-ms__fx');
  if (!fx) return;

  fx.classList.add('iv-fx-black');

  var tear = document.createElement('div');
  tear.className = 'iv-fx-tear';
  tear.setAttribute('aria-hidden', 'true');
  for (var j = 0; j < 3; j++) tear.appendChild(document.createElement('i'));
  fx.insertBefore(tear, fx.firstChild);

  var sub = fx.querySelector('.iv-ms__fx-sub');
  if (sub) sub.textContent = 'BY INVITATION ONLY.';

  var opened = false, done = false, userClosed = false;
  fx.addEventListener('click', function () { userClosed = true; }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') userClosed = true;
  }, true);

  var obs = new MutationObserver(function () {
    if (fx.classList.contains('is-on')) {
      if (!opened) {
        opened = true;
        window.setTimeout(function () { done = true; fx.classList.remove('is-on'); }, 8000);
      }
    } else if (opened && !done && !userClosed) {
      fx.classList.add('is-on');
    }
  });
  obs.observe(fx, { attributes: true, attributeFilter: ['class'] });
})();
